const state = {
  reactStore:
    [
      {
        id: 1,
        title_en: "React Essential 2021",
        title_ua: "React Базовий 2021",
        title_es: "React Básico 2021",
        regnumber: "TP20433727",
        grade: "1000 / 1000",
        examdate: "05.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp20433727",
      },
      {
        id: 2,
        title_en: "React Essential 2023",
        title_ua: "React Базовий 2023",
        title_es: "React Básico 2023",
        regnumber: "TP87727177",
        grade: "1000 / 1000",
        examdate: "06.09.2023",
        image: "https://testprovider.com/ru/search-certificate/tp87727177",
      },
      {
        id: 3,
        title_en: "React Advanced 2021",
        title_ua: "React Поглиблений 2021",
        title_es: "React Avanzado 2021",
        regnumber: "TP74208807",
        grade: "1000 / 1000",
        examdate: "09.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp74208807",
      },
      {
        id: 4,
        title_en: "React Advanced 2024",
        title_ua: "React Поглиблений 2024",
        title_es: "React Avanzado 2024",
        regnumber: "TP33851106",
        grade: "1000 / 1000",
        examdate: "13.04.2024",
        image: "https://testprovider.com/ru/search-certificate/tp33851106",
      },
      {
        id: 5,
        title_en: "React Native 2021",
        title_ua: "React Native 2021",
        title_es: "React Native 2021",
        regnumber: "TP06814422",
        grade: "1000 / 1000",
        examdate: "19.08.2021",
        image: "https://testprovider.com/ru/search-certificate/tp06814422",
      },
      {
        id: 6,
        title_en: "React Native 2024",
        title_ua: "React Native 2024",
        title_es: "React Native 2024",
        regnumber: "TP21660884",
        grade: "1000 / 1000",
        examdate: "12.05.2024",
        image: "https://testprovider.com/ru/search-certificate/tp21660884",
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};